import {useCallback} from 'react';
import {BackHandler, Platform} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';

import {getLinkTrail, goBackThroughLinkTrail} from '../../utils/navigation';

/**
 * Android hardware/gesture back for a screen reached through a same-route
 * in-page link (article -> article). The tab history holds no entry for the
 * origin — see `applyLinkTrail` in `utils/navigation` — so the default
 * GO_BACK skips straight past it. iOS has no hardware back and web uses the
 * browser's own history, so this is Android-only.
 */
export const useLinkTrailBack = (params: unknown): void => {
  useFocusEffect(
    useCallback(() => {
      if (Platform.OS !== 'android') return undefined;

      const trail = getLinkTrail(params);
      if (!trail) return undefined;

      const subscription = BackHandler.addEventListener('hardwareBackPress', () => {
        goBackThroughLinkTrail(trail);
        return true;
      });
      return () => subscription.remove();
    }, [params]),
  );
};
